import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from "../../auth/auth.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

/**
 * This component acts as the main "dashboard" for Online Claims users.
 * 
 * NOTE: This component currently has no explicit functionality and only hosts the existing claim form.
 */
@Component({
	selector: 'claims-app-dashboard',
	templateUrl: './claims-app-dashboard.component.html'
})
export class ClaimsAppDashboardComponent implements OnInit, OnDestroy {
	/**
	 * A subject that can be used to automatically end subscriptions when the component is destroyed.
	 * @private
	 */
	private readonly _destroying$ = new Subject<void>();

	/**
	 * @constructor
	 * @param authService The {@link AuthService} to use for login status checks.
	 */
	constructor(private authService: AuthService) { }

	ngOnInit(): void {
		this.authService.loginStatusChanged
			.pipe(takeUntil(this._destroying$))
			.subscribe(() => { });
	}
	ngOnDestroy(): void {
		this._destroying$.next(undefined);
		this._destroying$.complete();
	}
}